// Watermark intensity setting for the Saved-tab landmark watermarks.
// Values: "off" | "subtle" | "medium" | "bold". Default: "medium" (10%).
//
// Read by SavedTab.jsx LogCard; written by SettingsTab.jsx watermark row.

const KEY = "tiplingo_watermark_level_v1";

const OPACITY = {
  off: 0,
  subtle: 0.06,
  medium: 0.10,
  bold: 0.14,
};

const LABEL = {
  off: "Off",
  subtle: "Subtle",
  medium: "Medium",
  bold: "Bold",
};

export const WATERMARK_LEVELS = ["off", "subtle", "medium", "bold"];

export function getWatermarkLevel() {
  try {
    const v = localStorage.getItem(KEY);
    if (v && OPACITY[v] !== undefined) return v;
  } catch {}
  return "medium";
}

export function setWatermarkLevel(level) {
  try {
    if (OPACITY[level] === undefined) return;
    localStorage.setItem(KEY, level);
  } catch {}
}

export function getWatermarkOpacity(level) {
  return OPACITY[level] ?? OPACITY.medium;
}

export function getWatermarkLabel(level) {
  return LABEL[level] ?? LABEL.medium;
}
